<template>
  <v-dialog
      v-model ="dialog"
      max-width="500"
      persistent
    >
      <v-card flat class="dt-border pad-10">
          <v-btn
            icon
            absolute
            :disabled="loading"
            top
            right
            @click="$emit('closeModal')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <br>
        <v-card-title class="d-flex justify-center">
          <p class="text-center text-capitalize">Reverse {{detail.transactiontype}} Transaction</p>
        </v-card-title>
        <v-card-text align="center">
            <v-icon color="error" size="100px" >
                mdi-alert-circle-outline
            </v-icon>
            <br><br>
            <h2>Are you Sure ? </h2>
            <br>
            <p class="notice warning--text">You are about reversing {{ `${detail.user.profile.firstname} ${detail.user.profile.lastname}`}} {{detail.transactiontype}} transaction of {{formatMoney(detail.amount)}} </p>
          <br />
          <default-button :loading="loading" @click="reverse()">Yes, Reverse !</default-button>
        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
// ================ IMPORT COMPONENTS ================
import DefaultButton from "@/components/Buttons/default-button.vue";

// =========== IMPORT SERVICES ===========
import {WalletService} from '@/services';
import {formatMoney} from '@/utils/moneyFormatter';


export default{
    data:() => ({
        loading : false,
        checkbox:false,
    }),
    components: {
        DefaultButton,
    },
    mounted(){
        console.log(this.detail);
    },
    props:{
        detail:{
            type : Object
        },
        dialog:{
            type:Boolean,
            default:false
        },
    },
    methods:{
        async reverse(){
            try {
                this.loading = true;
                const data = await WalletService.reverseTransaction({
                    transactionid : this.detail.id,
                })
                this.loading = false;
                this.$emit('closeModal');
                this.$store.dispatch('toast', {
                    message: data.message,
                    variant: 'success'
                });
                this.$emit('reload')
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },
        formatMoney(amount){
            return formatMoney(amount)
        },
    }
}
</script>

<style lang="scss" scoped>
.notice{
    font-size: 20px !important;
}
</style>